import { useAppContext } from '@faro/app-context';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PropsWithChildren, ReactNode } from 'react';

export function AppQueryClientProvider(props: PropsWithChildren<unknown>): ReactNode {
    const { showErrorNotification } = useAppContext();

    const queryClient = new QueryClient({
        queryCache: new QueryCache({
            onError: error => {
                console.error('An error occurred fetching data', error);
                showErrorNotification('Server communication failure', error);
            },
        }),
        mutationCache: new MutationCache({
            onError: error => {
                console.error('An error occurred saving your data', error);
                showErrorNotification('An error occurred saving your data', error);
            },
        }),
    });

    return <QueryClientProvider client={queryClient}>{props.children}</QueryClientProvider>;
}
